import Vue from "vue";
import Vuex from "vuex";

import axios from "../axios";
import router from "../router/index";
import datapoints from "./modules/datapoints";
import studies from "./modules/studies";
import users from "./modules/users";
import tasks from "./modules/tasks";
import schemes from "./modules/schemes";
import onboarding from "./modules/onboarding";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    id: null,
    token: null,
    username: null,
    config: "",
    showModal: false,
    showLoginModal: false
  },
  mutations: {
    authUser(state, userData) {
      state.token = userData.token;
      state.username = userData.username;
      state.userid = userData.userid;
      axios.defaults.headers.common["Authorization"] =
        "Token " + userData.token;
    },
    setConfig(state, params) {
      state.config = params.config;
    },
    clearAuthData(state) {
      state.token = null;
      state.username = null;
      state.userid = null;
    },
    setLoginModalState(state, data) {
      state.showLoginModal = data;
    },
    toggleModalState(state) {
      state.showModal = !state.showModal;
    }
  },
  actions: {
    login({ commit, dispatch }, authData) {
      return axios.post("api-auth/token/", authData).then(res => {
        commit("authUser", {
			token: res.data.token,
			username: authData.username,
			userid: res.data.id
        });

        localStorage.setItem("userid", res.data.id);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("username", authData.username);

        dispatch("getConfig");
      });
    },

    getConfig({ commit }) {
      return axios.get("users/" + this.state.userid + "/").then(res => {
        commit("setConfig", {
          config: res.data.config
        });

        localStorage.setItem("config", res.data.config);
      });
    },

    autoLiginAttempt({ commit, dispatch }) {
      const token = localStorage.getItem("token");

      if (token) {
        const username = localStorage.getItem("username");
        const userid = localStorage.getItem("userid");

        commit("authUser", {
          token: token,
			username: username,
			userid: userid,
        });

        dispatch("getConfig");
      }
    },

    logout({ commit }) {
      commit("clearDatapoints");
      localStorage.removeItem("username");
      localStorage.removeItem("token");
      localStorage.removeItem("userid");
      delete axios.defaults.headers.common["Authorization"];
      commit("clearAuthData");
      router.push({ path: "/login" });
    },

    toggleModal({ commit }) {
      commit("toggleModalState");
    },

    openLoginModal({ commit }, showTutorial) {
      const firstTime = localStorage.getItem("firstTimeLogin");
      if (firstTime !== "false" || showTutorial) {
        commit("setLoginModalState", true);
      }
    },
    closeLoginModal({ commit }) {
      localStorage.setItem("firstTimeLogin", false);
      commit("setLoginModalState", false);
    }
  },
  getters: {
    token(state) {
      return state.token;
    },
    userid(state) {
      return state.userid;
    },
    username(state) {
      return state.username;
    },
    showModal(state) {
      return state.showModal;
    },
    showLoginModal(state) {
      return state.showLoginModal;
    },
    getExportService(state) {
		if (state.config && state.config.export_service)
			return state.config.export_service;
		return null;
    },
    getShowTasks(state) {
		if (state.config && state.config.show_tasks)
			return state.config.show_tasks;
		return null;
    },
    getShowStudies(state) {
		if (state.config && state.config.show_studies)
			return state.config.show_studies;
		return null;
    }
  },
  modules: {
    datapoints,
    studies,
    users,
    tasks,
    schemes,
    onboarding
  }
});
